(ns practitest.frontend.summary.external
  "External dashboard and embedded item (no login) in the new UI - the Summary page's cards, read only.
   Rendered by external_dashboards/show and item in the Rails app (see common-entities/init-external-summary)."
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.common.format-utils :as fu]
            [practitest.frontend.common.i18n :refer [format-translation get-translation]]
            [practitest.frontend.common.utils :as utils]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.init :as init]
            [practitest.frontend.summary.events :as events]
            [practitest.frontend.summary.subs :as subs]
            [practitest.frontend.summary.views :as views]))

(defn- auto-refresh? []
  (.has (js/URLSearchParams. (.-search js/window.location)) "auto_refresh"))

(defn- auto-refresh-url [on?]
  (let [url (js/URL. (.-href js/window.location))]
    (if on?
      (.set (.-searchParams url) "auto_refresh" "true")
      (.delete (.-searchParams url) "auto_refresh"))
    (.toString url)))

;; Same bar and logo as the app's top bar
(defn- page-bar []
  [:header.external-page-bar
   [icons/new-practitest-logo]])

(defn- toolbar [title]
  (let [tab-filter @(re-frame/subscribe [::subs/field :tab-filter])]
    [:div.summary-toolbar
     [:h3.external-summary-title title]
     (when tab-filter
       [views/tab-filter ::events/set-external-tab-filter])]))

(defn- status-line [{:keys [auto_refresh_minutes]}]
  (let [updated-at @(re-frame/subscribe [::subs/field :updated-at])]
    [:div.external-summary-status
     [:span (format-translation (get-translation "external-dashboard.last-updated" "Last updated: %{time}")
                                :time (fu/formatted-date-time updated-at))]
     (if (auto-refresh?)
       [:<>
        [:span (format-translation (get-translation "external-dashboard.auto-refresh.on"
                                                    "This page updates automatically every %{minutes} minutes.")
                                   :minutes auto_refresh_minutes)]
        [:a.external-summary-status-link {:href (auto-refresh-url false)}
         (get-translation "external-dashboard.auto-refresh.stop" "Stop auto update")]]
       [:a.external-summary-status-link {:href (auto-refresh-url true)}
        (format-translation (get-translation "external-dashboard.auto-refresh.start"
                                             "Update this page automatically every %{minutes} minutes")
                            :minutes auto_refresh_minutes)])]))

(defn- page-footer []
  [:footer.external-page-footer
   [:div.external-page-footer-links
    [:a.external-page-footer-link {:href "http://practitest.uservoice.com/" :target "_blank" :rel "noopener noreferrer"}
     (get-translation "external-dashboard.footer.product-feedback" "Product Feedback")]
    [:a.external-page-footer-link {:href "mailto:support@practitest.com?subject=PractiTest Support Request" :target "_blank" :rel "noopener noreferrer"}
     (get-translation "external-dashboard.footer.support" "Support")]
    [:a.external-page-footer-link {:href "https://www.practitest.com/blog/" :target "_blank" :rel "noopener noreferrer"}
     (get-translation "external-dashboard.footer.qablog" "QABlog")]]
   [:span (format-translation (get-translation "external-dashboard.footer.copyright"
                                               "© 2008-%{year} PractiTest is a product by H.S. PractiTest Ltd. All Rights Reserved.")
                              :year (.getFullYear (js/Date.)))]])

(defn- content [single?]
  (let [loading?    @(re-frame/subscribe [::subs/field :loading?])
        load-error? @(re-frame/subscribe [::subs/field :load-error?])
        items       @(re-frame/subscribe [::subs/field :items])
        reload-key  @(re-frame/subscribe [::subs/field :reload-key])
        external    @(re-frame/subscribe [::subs/field :external])
        url         @(re-frame/subscribe [::subs/field :external-url])]
    (cond
      (and loading? (nil? external))
      [:div.summary-loading [spinners/mux-spinner]]

      load-error?
      [:div.summary-empty
       [:span (get-translation "generic.error.general" "Something went wrong. Please try again.")]
       [buttons/button {:text     (get-translation "generic.button.retry" "Retry")
                        :on-click #(re-frame/dispatch [::events/fetch-external url])}]]

      :else
      [:<>
       (when-not single?
         [toolbar (:title external)])
       [:div.summary-body {:class (when loading? "loading")}
        (if (:archived external)
          [:div.summary-empty (get-translation "dashboards.archived" "This dashboard is archived")]
          [:f> views/cards-grid items false reload-key])]
       (when-not single?
         [status-line external])])))

;; data-single - only the embedded item's card, filling the page (no header / footer)
(defn root-view [{:keys [data-single]}]
  (let [single? (= "true" data-single)]
    [:div.summary-page.external-summary {:class (when single? "single")}
     (when-not single?
       [page-bar])
     [content single?]
     (when-not single?
       [page-footer])]))

(defn ^:dev/after-load remount-roots []
  (init/remount-roots "external-summary-component" root-view))

(utils/register-webcomponent! "external-summary-component")
